// @vendors
const React = require("react");
const PropTypes = require("prop-types");

// @ utils
const { formatText } = require("core/i18n").i18n;

// @components
const PassContainer = require("components/contactCenter/passContainer/passContainer");
const { OKButton } = require("components/commons/OKButton/OKButton");
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const { OKInput } = require("commonsComponents/OKInput");

require("./KeysCCStep2.scss");

class KeysCCStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            codeOTP: ""
        };
        this.handleOTPChange = this.handleOTPChange.bind(this);
        this.handleSendKey = this.handleSendKey.bind(this);
        this.handleRequestNewCode = this.handleRequestNewCode.bind(this);
        this.builFormInfo = this.builFormInfo.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (
            this.props.resetCounter !== nextProps.resetCounter &&
            nextProps.resetCounter
        ) {
            this.setState({
                codeOTP: ""
            });
        }
    }

    isReady() {
        return this.props.immProfileFields.get("isFetching");
    }

    builFormInfo() {
        const inputInfo1 = formatText("keysCCStep2-inputInfo1");
        const inputInfo2 = formatText("keysCCStep2-inputInfo2");

        return (
            <span>
                <span>{inputInfo1}</span>
                <OKButton
                    modifier="link-complementary"
                    size="one-character"
                    onClick={this.handleRequestNewCode}
                >
                    {inputInfo2}
                </OKButton>
            </span>
        );
    }

    handleOTPChange(event) {
        this.props.setOTPCode(event.target.value.trim().toUpperCase());
    }

    handleRequestNewCode() {
        this.props.requestCodeOTP();
    }

    handleSendKey() {
        const { codeOTP } = this.state;

        this.props.requestKey(codeOTP);
    }

    render() {
        const { inlineErrorMessage, titleStep, currentStep } = this.props;
        const step = 2;
        const title = titleStep;
        const confirmMessage = formatText("keysCCStep2-confirmMessage");
        const inputLabel = formatText("keysCCStep2-inputLabel");
        const inputInfo = this.builFormInfo();
        const disable = currentStep == step;

        return (
            <PassContainer
                title={title}
                disable={!disable}
            >
                <div className="keys-cc-step2 no-print-out">
                    <BlockInfo>
                        <p className="keys-cc-step2__message-column">
                            {confirmMessage}
                        </p>

                        <div className="keys-cc-step2__form-column">
                            <p>{inputLabel}</p>
                            <div className="keys-cc-step2__form-box">
                                <OKInput
                                    // label=
                                    errorState={!!inlineErrorMessage}
                                    errorMessage={inlineErrorMessage}
                                    onChange={this.handleOTPChange}
                                />
                            </div>
                            <div className="keys-cc-step2__help-box">
                                {inputInfo}
                            </div>
                        </div>
                    </BlockInfo>
                </div>
            </PassContainer>
        );
    }
}

KeysCCStep2.propTypes = {
    hasBeenSent: PropTypes.bool.isRequired,
    hasError: PropTypes.string,
    currentStep: PropTypes.number.isRequired,
    requestKey: PropTypes.func.isRequired,
    requestCodeOTP: PropTypes.func.isRequired,
    isFetchingOTP: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    immProfileFields: PropTypes.object,
    inlineErrorMessage: PropTypes.string,
    titleStep: PropTypes.string.isRequired,
    isDisaster: PropTypes.bool,
    resetCounter: PropTypes.number.isRequired,

    setOTPCode: PropTypes.func.isRequired
};

KeysCCStep2.defaultProps = {
    isDisaster: false
};

module.exports = KeysCCStep2;
